<template>
	<button
		class="roundup-button-old"
		:disabled="disabled"
		:type="nativeType || 'button'"
		:class="[color, { loading: loading }]"
		@click="$emit('click', this)"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'roundup-button',
	props: ['color', 'nativeType', 'loading', 'disabled']
}
</script>

<style lang="scss">
.roundup-button-old,
.plaid-link-button {
	width: 100%;
	background: $navy;
	border: 0px;
	color: #fff;
	font-size: 20px;
	line-height: 20px;
	font-weight: bold;
	border-radius: 10px;
	box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
	padding: 18px 35px;
	cursor: pointer;
	transition: all 0.25s ease-in-out;
	position: relative;
	text-transform: uppercase;
	&:disabled {
		background: $dark-grey;
	}
	&:hover:enabled {
		box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
		transform: translateY(-2px);
	}
	&.white,
	&.cerulean {
		background: $white;
		color: $navy;
		&.cerulean {
			color: $cerulean;
		}
		&.border {
			border: 1px solid $navy;
		}
	}
	&.mint {
		background: rgba(0, 0, 0, 0.12);
		box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
	}
	&.navy {
		background: $navy-highlight;
	}
	&.pink {
		background: $red-highlight;
	}
	&.purple {
		background: $purple-highlight;
	}
	&.clear {
		background: transparent;
		box-shadow: none;
		color: $navy;
		&.border {
		}
		border: 1px solid $navy;
	}
	&.clear-white {
		background: transparent;
		box-shadow: none;
		color: $white;
		border: 1px solid white;
	}

	&.loading {
		padding-right: 55px;
		&:before {
			content: '';
			position: absolute;
			display: block;
			width: 0px;
			height: 0px;
			border-radius: 50%;
			right: 15px;
			top: 25px;
			border: 2px solid rgba(255, 255, 255, 0.8);
			border-right: 2px solid $navy;
			animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
		}
	}
}

.plaid-link-button {
	background: $white !important;
	color: $navy !important;
}

.info-button {
	height: 40px;
	border-radius: 20px;
	margin: 20px;
	margin-left: 0px;
	display: flex;
	width: auto;
	font-size: 14px;
	font-weight: 400;
	justify-content: flex-start;
	flex-direction: row;
	align-items: center;
	text-transform: none;
}
</style>
